// Return a rendition large enough for the magnified view: displayed size x zoom x device pixel ratio.
// Shopify's CDN caps at the original upload, so oversizing never upscales.
function magnifySrc(image, zoomRatio) {
  try {
    const url = new URL(image.src, window.location.origin);
    const targetWidth = Math.min(4096, Math.ceil(image.width * zoomRatio * (window.devicePixelRatio || 1)));
    const currentWidth = parseInt(url.searchParams.get('width'), 10);
    if (!currentWidth || currentWidth < targetWidth) {
      url.searchParams.set('width', String(targetWidth));
    }
    return url.href;
  } catch (e) {
    return image.src;
  }
}

// create a container and set the full-size image as its background
function createOverlay(image, zoomRatio) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', magnifySrc(image, zoomRatio));
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('data-src',image.src);
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image, zoomRatio);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    // image.onclick = (event) => {
    //   magnify(image, zoomRatio);
    //   moveWithHover(image, event, zoomRatio);
    // };
    image.addEventListener('mouseover',(e)=>{
      magnify(image, zoomRatio);
      moveWithHover(image, e, zoomRatio);
    })
  });
}


function disableZoomOnHover() {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    // Remove existing event listeners by cloning and replacing the node
    const newImage = image.cloneNode(true);
    image.parentNode.replaceChild(newImage, image);
  });
  // Remove any existing overlays
  const overlays = document.querySelectorAll('.image-magnify-full-size');
  overlays.forEach((overlay) => overlay.remove());
}

function initZoomOnHover() {
  if (window.innerWidth >= 750) {
    enableZoomOnHover(2);
  } else {
    disableZoomOnHover();
  }
}

function handleResize() {
  initZoomOnHover();
}

// Initialize on load
initZoomOnHover();

// Handle window resize
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(handleResize, 250);
});
